module.exports = {
  social_deduction_games_online: {
    title: 'Jogos de dedução social online com amigos | Avalon',
    description:
      'Compare Avalon, Secret Hitler, Lobisomem e Among Us para 5–10 amigos: navegador ou download, contas, eliminação e como experimentar com bots.',
    keywords: ['jogos de dedução social online'],
    breadcrumbs: [
      {
        to: '/pt/',
        title: 'Início',
      },
      {
        to: '/pt/guides/social-deduction-games-online/',
        title: 'Jogos de dedução social online',
      },
    ],
  },
  games_like_secret_hitler: {
    title: 'Jogos parecidos com Secret Hitler: Avalon online',
    description:
      'Compare Secret Hitler e Avalon: governos ou equipes de missão, pistas, Merlin e participação. Experimente Avalon no navegador com sua turma.',
    keywords: ['jogos parecidos com Secret Hitler'],
    breadcrumbs: [
      {
        to: '/pt/',
        title: 'Início',
      },
      {
        to: '/pt/guides/social-deduction-games-online/',
        title: 'Jogos de dedução social online',
      },
      {
        to: '/pt/guides/games-like-secret-hitler/',
        title: 'Jogos parecidos com Secret Hitler',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: 'Avalon vs Lobisomem: sem eliminação precoce',
    description:
      'Compare Avalon com Lobisomem, o jogo de cartas, e Máfia: missões, votos e participação sem eliminação precoce. Para 5–10 amigos ou com bots.',
    keywords: ['Avalon vs Lobisomem'],
    breadcrumbs: [
      {
        to: '/pt/',
        title: 'Início',
      },
      {
        to: '/pt/guides/social-deduction-games-online/',
        title: 'Jogos de dedução social online',
      },
      {
        to: '/pt/guides/avalon-vs-werewolf/',
        title: 'Avalon vs Lobisomem',
      },
    ],
  },
};
